export const getEventIcon = (type, config)=>{
  return L.icon({
    iconUrl: getEventIconUrl(type),
    iconSize: [28, 28],
    iconAnchor: [14, 14],
    ...config,
  });
}

const context = require.context('@/assets/icon/event-marker', false, /\.png$/);
const filePaths = context.keys();
const fileNames = filePaths.map(path => path.replace(/^\.\//, '').replace(/\.png$/, ''));

export const getEventIconUrl = (type)=>{
  if(fileNames.includes(type)){
    return context(`./${type}.png`);
  }else{
    return context(`./default.png`);
  }
}